import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelRadio as _vModelRadio, vShow as _vShow, withKeys as _withKeys, Transition as _Transition, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("label", {
  for: "query",
  class: "sr-only"
}, "Address", -1)
const _hoisted_2 = ["placeholder"]
const _hoisted_3 = { class: "w-full px-2 py-1 inline-flex items-center space-x-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "address" }, "Address or intersection", -1)
const _hoisted_5 = { class: "w-full px-2 py-1 inline-flex items-center space-x-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "taxlot" }, "Tax lot number", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Box = _resolveComponent("Box")!

  return (_openBlock(), _createBlock(_component_Box, {
    as: "form",
    color: "gray",
    variant: "light",
    title: "Search",
    class: "flex flex-col border border-current shadow-md rounded-md",
    onSubmit: _withModifiers(_ctx.handleSubmit, ["prevent"])
  }, {
    default: _withCtx(() => [
      _createElementVNode("section", {
        class: _normalizeClass(["inline-flex flex-wrap items-center border-current", { 'border-b': _ctx.open }])
      }, [
        _createVNode(_component_Button, {
          type: "button",
          color: "transparent",
          label: "Search settings",
          id: "menu-button",
          tabindex: "0",
          class: _normalizeClass(["flex rounded-l-md focus:ring-2 focus:ring-blue-500", { 'rounded-bl-none': _ctx.open }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.open = !_ctx.open))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Icon, {
              type: "solid",
              name: "adjustment",
              class: "w-6 h-6"
            })
          ]),
          _: 1
        }, 8, ["class"]),
        _hoisted_1,
        _withDirectives(_createElementVNode("input", {
          id: "query",
          name: "query",
          type: "text",
          role: "searchbox",
          placeholder: _ctx.placeholder,
          tabindex: "0",
          required: "",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.query) = $event)),
          class: "flex-1 min-w-0 appearance-none bg-transparent border-transparent placeholder-gray-600"
        }, null, 8, _hoisted_2), [
          [_vModelText, _ctx.query]
        ]),
        _createVNode(_component_Button, {
          type: "submit",
          color: "transparent",
          label: "Search",
          tabindex: "0",
          class: _normalizeClass(["flex rounded-r-md focus:ring-2 focus:ring-blue-500", { 'rounded-br-none': _ctx.open }])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Icon, {
              type: "solid",
              name: "search",
              class: "w-6 h-6"
            })
          ]),
          _: 1
        }, 8, ["class"])
      ], 2),
      _createVNode(_Transition, {
        "enter-active-class": "transition ease-out duration-100",
        "enter-from-class": "transform opacity-0 scale-95",
        "enter-to-class": "transform opacity-100 scale-100",
        "leave-active-class": "transition ease-in duration-75",
        "leave-from-class": "transform opacity-100 scale-100",
        "leave-to-class": "transform opacity-0 scale-95"
      }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("section", {
            class: "p-2",
            onKeydown: _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.handleTab && _ctx.handleTab(...args)), ["tab"]))
          }, [
            _createElementVNode("div", _hoisted_3, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                id: "address",
                name: "searchType",
                tabindex: "0",
                value: "address",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.type) = $event))
              }, null, 512), [
                [_vModelRadio, _ctx.type]
              ]),
              _hoisted_4
            ]),
            _createElementVNode("div", _hoisted_5, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                id: "taxlot",
                name: "searchType",
                tabindex: "0",
                value: "taxLot",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.type) = $event))
              }, null, 512), [
                [_vModelRadio, _ctx.type]
              ]),
              _hoisted_6
            ])
          ], 544), [
            [_vShow, _ctx.open]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onSubmit"]))
}